{
  "list": {
    "title": "Notificações"
  },
  "planExport": {
    "download": "Baixar",
    "view": "Visualizar",
    "completed": "concluído",
    "failed": "não pôde ser concluído",
    "inProgress": "está em andamento",
    "export": "exportar",
    "completedStatus": "Concluído",
    "failedStatus": "Falhou",
    "inProgressStatus": "Em andamento"
  },
  "markAsRead": "Marcar como lido",
  "noNotifications": "No momento, não há notificações.",
  "layersImport": {
    "in-progress": {
      "title": "Importando camadas",
      "description": "Importando camadas: {{ name }}"
    },
    "completed": {
      "title": "Importação de camadas concluída",
      "description": "Importação de camadas concluída: {{ name }}"
    },
    "failed": {
      "title": "Falha ao importar camadas",
      "description": "Falha ao importar camadas: {{ name }}"
    },
    "goToMap": "Vá para o mapa"
  },
  "layersCopy": {
    "in-progress": {
      "title": "Copiando camadas",
      "description": "Copiando camadas: {{ name }}"
    },
    "completed": {
      "title": "Copiar camadas concluídas",
      "description": "Copiar camadas concluídas"
    },
    "failed": {
      "title": "Falha ao copiar camadas",
      "description": "Falha ao copiar camadas: {{ name }}"
    },
    "goToMap": "Vá para o mapa"
  },
  "layersUnlink": {
    "in-progress": {
      "title": "Desvinculando camadas",
      "description": "Desvinculando camadas: {{ name }}"
    },
    "completed": {
      "title": "Desvinculação de camadas concluída",
      "description": "Desvinculação de camadas concluída"
    },
    "failed": {
      "title": "Falha ao desvincular camadas",
      "description": "Falha ao desvincular camadas: {{ name }}"
    },
    "goToMap": "Vá para o mapa"
  },
  "mapsCopy": {
    "in-progress": {
      "title": "Copiando plano (s)",
      "description": "Copiando para: {{ destinationName }}"
    },
    "completed": {
      "title": "Copiar plano (s) concluído (s)",
      "description": "Copiado para: {{ destinationName }}"
    },
    "goToLocation": "Vá para {{ destinationName }}",
    "teamMapLimitReached": "Limite de planos de equipe atingido.",
    "somePlansWereNotCopied": "Alguns planos não foram copiados.",
    "somePlansFailedToCopy": "Alguns planos não foram copiados."
  }
}